/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_n_letter_words = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}-letter words`)
};

const es_wu_n_letter_words = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palabras de ${i?.n} letras`)
};

const de_wu_n_letter_words = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}-Buchstaben-Wörter`)
};

const nl_wu_n_letter_words = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Woorden van ${i?.n} letters`)
};

const fr_wu_n_letter_words = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mots de ${i?.n} lettres`)
};

const it_wu_n_letter_words = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Parole di ${i?.n} lettere`)
};

const pt_br2_wu_n_letter_words = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palavras com ${i?.n} letras`)
};

const pt_wu_n_letter_words = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palavras de ${i?.n} letras`)
};

const ja_wu_n_letter_words = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}文字の単語`)
};

const zh_wu_n_letter_words = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 个字母的单词`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ n: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_n_letter_words = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_n_letter_words(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_n_letter_words", locale)
	if (locale === "en") return en_wu_n_letter_words(inputs)
	if (locale === "es") return es_wu_n_letter_words(inputs)
	if (locale === "de") return de_wu_n_letter_words(inputs)
	if (locale === "nl") return nl_wu_n_letter_words(inputs)
	if (locale === "fr") return fr_wu_n_letter_words(inputs)
	if (locale === "it") return it_wu_n_letter_words(inputs)
	if (locale === "pt-BR") return pt_br2_wu_n_letter_words(inputs)
	if (locale === "pt") return pt_wu_n_letter_words(inputs)
	if (locale === "ja") return ja_wu_n_letter_words(inputs)
	return zh_wu_n_letter_words(inputs)
};